import { adminHttpClient } from '../../../commons/adminHttpClient'
import { WizardStatus } from '../../../../domain/wizard/wizard'

export interface PerksBenefitDesignStateValues {
  benefitStartDate: string
  isBenefitEditable: boolean
  planPeriodId: string
  wizardStatus: WizardStatus
}

const getPerksBenefitDesignState = (planPeriodId: string): Promise<PerksBenefitDesignStateValues> => {
  return adminHttpClient.get(`/AdminDashboard/perks/BenefitDetails/BenefitDesignWizardState/${planPeriodId}`)
}

export default getPerksBenefitDesignState
